import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./../slices/authSlice";
import DashboardReducer from "./../slices/dashboardSlice";
import generalSliceReducer from "./../slices/generalSlice";
import ordersSliceReducer from "./../slices/ordersSlice";
import formulasSliceReducer from "./../slices/formulasSlice";
import ChatReducer from "./../slices/chatSlice";
import newsLetterReducer from "../slices/newsLetterSlice";
import waitingListReducer from "../slices/waitingListSlice";
import { useDispatch } from "react-redux";
export const store = configureStore({
  reducer: {
    general: generalSliceReducer,
    auth: AuthReducer,
    dashboard: DashboardReducer,
    orders: ordersSliceReducer,
    formulas: formulasSliceReducer,
    chat: ChatReducer,
    newsLetter: newsLetterReducer,
    waitingList: waitingListReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
